import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";
import moment from "moment";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import useWindowDimensions from "src/utils/windowDimension";
import { CRow } from "@coreui/react";
import { currencyOptions } from "src/utils/currencies";
import './CashFlowHolding.scss'
import "../../../../flujocaja/flujo-caja.scss";
import { GetHoldingFlow, GetHoldingFlowStructure, MergeCategoryAreas } from "src/graphql/cashflowHolding";
import RightSidebar from "src/components/general/js/RightSidebar";
import { LoadingCurrencyMessage, LoadingProjectionMessage, LoadingOnlyEstimationsMessage, LoadingViewMessage } from "src/components/flujocaja(new)/functions";
import { getUpdateHoldingCashFlowStructureNeeded, importUpdateHoldingCashFlowNeeded } from "src/redux/actions/holdingCashFlow";
import { importOpenSidebar } from "src/redux/actions/openSidebar";
import { importAlertState } from "src/redux/actions/alert";
import HoldingFlow from "./FlowHolding";
import { MergeAreasModal } from "./MergeAreasModal";
import CustomModal from "src/components/configuracion/components/customModal";
import LoadingSpinner from "src/components/general/js/spinnerLoading";
import InitialBalance from "src/components/flujocaja/initialBalance";
import ExportCashFlow from "src/components/general/js/forms/exportCashFlow/ExportCashFlow";
import FlowDetail from "src/components/flujocaja(new)/fieldDetail";
import captureFlowTableScreenshot from "src/components/flujocaja(new)/captureFlowTableScreenshot";

const VIEW_TYPE = {
  day: "day",
  week: "week",
  month: "month",
};

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export const CashFlowHolding = ({selectedCompanies}) => {
  const dispatch = useDispatch();
  const screenshotRef = useRef(null);
  const screenshotPrepareRef = useRef(null);
  const { selectedCompany, excludeIntercompanyReports } = useSelector((state) => state.companyList);
  const excludeIntercompany = Boolean(excludeIntercompanyReports);

  const { updateHoldingCashFlowNeeded, updateHoldingCashFlowStructure } = useSelector(
    (state) => state.holdingCashFlow
  );

  const { openSidebar } = useSelector((state) => state.openSidebar);
  const user = useSelector((state) => state.auth);

  const companyId = selectedCompany.id;
  const defaultView = user?.flowView
    ? user.flowView.find((f) => f?.companyId == companyId)
    : VIEW_TYPE.month;

  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);

  const [nameSelected, setNameSelected] = useState();
  const [tableHeight, setTableHeight] = useState();

  const [checkSwitch, setCheckSwitch] = useState(false);

  const [showAll, setShowAll] = useState(false);
  const [checkSwitchShowProjections, setCheckSwitchShowProjections] = useState(true);
  const [checkSwitchOnlyEstimations, setCheckSwitchOnlyEstimations] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [updateCompress, setUpdateCompress] = useState(true);
  const [currency, setCurrency] = useState("CLP");
  const [view, setView] = useState(VIEW_TYPE.month);
  const [loadingMsg, setLoadingMsg] = useState("Cargando...");

  const [viewType, setViewType] = useState();

  const Start = useState();
  const End = useState();

  const { height } = useWindowDimensions();

  const [areaFilter, setAreaFilter] = useState('');
  const [filterInputValue, setFilterInputValue] = useState('');

  const { data, fetching: holdingFlowFetching, reexecuteHoldingFlow } = GetHoldingFlow({
    companyIds: selectedCompanies,
    currency,
    view,
    showProjections: checkSwitchShowProjections,
    onlyEstimations: checkSwitchOnlyEstimations,
    areaFilter: areaFilter,
    excludeIntercompany,
  })

  const { data: holdingFlowStructure, reExecuteQuery: reExecuteQueryHoldingFlowStructure } = GetHoldingFlowStructure({ companyIds: selectedCompanies });

  const [mergeAreasModalIsOpen, setMergeAreasModalIsOpen] = useState(false);
  const [mergeAreasModalData, setMergeAreasModalData] = useState();
  const [areaConflictsModalOpen, setAreaConflictsModalOpen] = useState(false);
  const [areaConflicts, setAreaConflicts] = useState([]);
  const [areaConflictDecisions, setAreaConflictDecisions] = useState({});
  const [initialConflictDecisions, setInitialConflictDecisions] = useState({});
  const [areaConflictNames, setAreaConflictNames] = useState({});
  const [conflictsReviewDeferred, setConflictsReviewDeferred] = useState(false);
  const { executeMutation: mergeCategoryAreasExecuteMutation } = MergeCategoryAreas();

  const [isFirstRender, setIsFirstRender] = useState(true);

  const [viewDropdownOpen, setViewDropdownOpen] = useState(false);
  const viewDropdownRef = useRef(null);
  const [viewModeOpen, setViewModeOpen] = useState(false);
  const viewModeRef = useRef(null);
  const [currencyOpen, setCurrencyOpen] = useState(false);
  const currencyRef = useRef(null);
  const [viewMode, setViewMode] = useState("real_projected");

  const CURRENCY_OPTIONS = [
    ...currencyOptions,
    { key: "UF", value: "UF", flag: "cl", text: "UF" },
    { key: "UTM", value: "UTM", flag: "cl", text: "UTM" },
  ];

  const normalizeLabel = (label) => (label || '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
  const buildAreaRef = (areaId, categoryId, label) => `${areaId}::${categoryId}::${normalizeLabel(label)}`;
  const isAreaAlreadyMerged = (field) => {
    const hasMergedFromData = Array.isArray(field?.mergedFrom)
      ? field.mergedFrom.length > 0
      : !!field?.mergedFrom;
    return !!field?.isMerged || hasMergedFromData;
  };
  const conflictStorageKey = `holding-area-conflicts-${[...(selectedCompanies || [])].sort().join('-')}`;
  const getConflictKey = (conflict) =>
    `${conflict.conflictType || "areaId-label"}-${conflict.reportType}-${conflict.categoryId}-${conflict.areaId}-${(conflict.labels || []).map(normalizeLabel).sort().join('|')}`;
  const conflictsCount = areaConflicts.length;
  const combinedCount = Object.values(areaConflictDecisions).filter((decision) => decision === "merge").length;
  const separatedCount = Object.values(areaConflictDecisions).filter((decision) => decision === "separate").length;
  const hasUnsavedConflictChanges =
    JSON.stringify(areaConflictDecisions) !== JSON.stringify(initialConflictDecisions);

  const detectAreaConflicts = (report) => {
    const conflicts = [];
    const processReportType = (reportType) => {
      const categories = report?.[reportType] || [];

      // Conflict type A: same cashflowAreaId but different labels, within the same category (existing behavior)
      categories.forEach((category) => {
        const groupedByAreaId = {};
        (category?.fields || []).forEach((field) => {
          if (!field?.cashflowAreaId) return;
          if (isAreaAlreadyMerged(field)) return;
          const idKey = field.cashflowAreaId.toString();
          if (!groupedByAreaId[idKey]) groupedByAreaId[idKey] = [];
          groupedByAreaId[idKey].push(field);
        });

        Object.keys(groupedByAreaId).forEach((areaId) => {
          const groupFields = groupedByAreaId[areaId];
          const distinctLabels = [...new Set(groupFields.map((f) => normalizeLabel(f?.label)).filter(Boolean))];
          if (distinctLabels.length > 1) {
            const conflictData = {
              conflictType: "areaId-label",
              reportType,
              categoryId: category.cashflowCategoryId,
              categoryLabel: category.label,
              areaId,
              labels: groupFields.map((f) => f.label),
              areaRefs: groupFields.map((f) =>
                buildAreaRef(f.cashflowAreaId, category.cashflowCategoryId, f.label)
              ),
              mergedAreaName: groupFields[0]?.label || `Área ${areaId}`
            };
            conflicts.push({
              ...conflictData,
              conflictKey: getConflictKey(conflictData),
            });
          }
        });
      });

      // Conflict type B: same cashflowAreaId appearing in different categories across companies
      // (e.g. seeded/default area IDs reused with different names in each company's flow)
      const globalAreaIndex = {};
      categories.forEach((category) => {
        (category?.fields || []).forEach((field) => {
          if (!field?.cashflowAreaId) return;
          if (isAreaAlreadyMerged(field)) return;
          const idKey = field.cashflowAreaId.toString();
          if (!globalAreaIndex[idKey]) globalAreaIndex[idKey] = [];
          globalAreaIndex[idKey].push({ category, field });
        });
      });

      Object.keys(globalAreaIndex).forEach((areaId) => {
        const entries = globalAreaIndex[areaId];
        const distinctCategoryIds = [...new Set(entries.map((e) => e.category.cashflowCategoryId?.toString()))];
        if (distinctCategoryIds.length <= 1) return;

        // Skip if already captured as type A for this areaId in this reportType
        const alreadyInTypeA = conflicts.some(
          (c) => c.conflictType === "areaId-label" && c.areaId === areaId && c.reportType === reportType
        );
        if (alreadyInTypeA) return;

        const conflictData = {
          conflictType: "areaId-category",
          reportType,
          categoryId: entries[0].category.cashflowCategoryId,
          categoryLabel: entries.map((e) => e.category.label).join(" / "),
          areaId,
          labels: entries.map((e) => e.field.label),
          areaRefs: entries.map((e) =>
            buildAreaRef(e.field.cashflowAreaId, e.category.cashflowCategoryId, e.field.label)
          ),
          mergedAreaName: entries[0].field.label || `Área ${areaId}`,
        };
        conflicts.push({ ...conflictData, conflictKey: getConflictKey(conflictData) });
      });
    };

    processReportType('INCOME');
    processReportType('EXPENSE');
    return conflicts;
  };

  const VIEW_OPTIONS = [
    { key: VIEW_TYPE.month, text: "Mensual", value: VIEW_TYPE.month },
    { key: VIEW_TYPE.week, text: "Semanal", value: VIEW_TYPE.week },
    { key: VIEW_TYPE.day, text: "Diario", value: VIEW_TYPE.day },
  ];

  const VIEW_MODE_OPTIONS = [
    { key: "real_projected", text: "Real + Estimado", value: "real_projected" },
    { key: "projected_only", text: "Solo Estimado", value: "projected_only" },
    { key: "real_only", text: "Solo Real", value: "real_only" },
  ];

  useEffect(async () => {
    if (updateHoldingCashFlowNeeded?.value) {
      await delay(500);
      reexecuteHoldingFlow({ requestPolicy: "network-only" });
      dispatch(importUpdateHoldingCashFlowNeeded({ value: false, reload: null }));
    }
  }, [updateHoldingCashFlowNeeded?.value]);

  useEffect(() => {
    if (!isFirstRender) return;
    setIsFirstRender(false);
  })

  useEffect(async () => {
    if (updateHoldingCashFlowStructure?.value) {
      reExecuteQueryHoldingFlowStructure({ requestPolicy: "network-only" });
      dispatch(getUpdateHoldingCashFlowStructureNeeded({ value: false }));
    }
  }, [updateHoldingCashFlowStructure?.value]);

  useEffect(() => {
    const [_, setStartDate] = Start;

    setStartDate(moment().startOf(view).subtract(1, view).format("YYYY-MM-DD"));
    // dispatch(importOpenSidebar({ show: false }));
    // dispatch(importUpdateCashflowNeeded({ value: false, reload: false }))
    reexecuteHoldingFlow({ requestPolicy: 'network-only' });
  }, [companyId, excludeIntercompany])

  useEffect(() => {
    var lessHeight = document.getElementsByClassName("c-header");
    const res = height - lessHeight[0]?.clientHeight * 2;
    setTableHeight(res);
  }, [height]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (viewDropdownRef.current && !viewDropdownRef.current.contains(e.target)) setViewDropdownOpen(false);
      if (viewModeRef.current && !viewModeRef.current.contains(e.target)) setViewModeOpen(false);
      if (currencyRef.current && !currencyRef.current.contains(e.target)) setCurrencyOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const onViewModeChange = (value) => {
    setViewMode(value);
    switch (value) {
      case "real_projected":
        setCheckSwitchShowProjections(true);
        setCheckSwitchOnlyEstimations(false);
        break;
      case "projected_only":
        setCheckSwitchShowProjections(true);
        setCheckSwitchOnlyEstimations(true);
        break;
      case "real_only":
        setCheckSwitchShowProjections(false);
        setCheckSwitchOnlyEstimations(false);
        break;
    }
    dispatch(importUpdateHoldingCashFlowNeeded({ value: false, reload: true }));
  };

  const plus = () => {
    if (!data?.getHoldingCashFlow) return null;

    const [startDate, setStartDate] = Start;
    const [endDate, setEndDate] = End;

    if (
      view == VIEW_TYPE.month &&
      moment(endDate) >=
      moment().add(data?.getHoldingCashFlow?.futureMonthsView || 12, view)
    )
      return null;
    setStartDate(
      moment(startDate)
        .startOf(view)
        .add(1, view)
        .format("YYYY-MM-DDTHH:mm:ss.SSS")
    );
    setEndDate(
      moment(endDate).endOf(view).add(1, view).format("YYYY-MM-DDTHH:mm:ss.SSS")
    );
  };

  const less = () => {
    if (!data?.getHoldingCashFlow) return null;

    const [startDate, setStartDate] = Start;
    const [endDate, setEndDate] = End;

    if (
      view == VIEW_TYPE.month &&
      moment(startDate) <= moment().subtract(12, view)
    )
      return null;
    setStartDate(
      moment(startDate)
        .startOf(view)
        .subtract(1, view)
        .format("YYYY-MM-DDTHH:mm:ss.SSS")
    );
    setEndDate(
      moment(endDate)
        .endOf(view)
        .subtract(1, view)
        .format("YYYY-MM-DDTHH:mm:ss.SSS")
    );
  };

  const addViewTypeParam = (type) => {
    searchParams.set("view_type", type);

    history.push({ search: searchParams.toString() });
  };

  const addCurrencyParam = (type) => {
    searchParams.set("currency", type);

    history.push({ search: searchParams.toString() });
  };

  const addShowProjectionsParam = (_, value) => {
    const showProjections = value?.checked;

    searchParams.set("projections", showProjections);
    history.push({ search: searchParams.toString() });
  };

  useEffect(() => {
    if (
      (!holdingFlowFetching && updateHoldingCashFlowNeeded?.reload === true) ||
      data ||
      holdingFlowStructure?.getFlowStructure
    ) {
      const urlViewType = searchParams.get("view_type");
      const urlCurrency = searchParams.get("currency");
      const urlProjections = searchParams.get("projections") === "true";

      if (!urlViewType) {
        addViewTypeParam(view);
      } else if (urlViewType !== view) {
        onViewChange(urlViewType);
      }

      if (!urlCurrency) {
        addCurrencyParam(currency);
      } else if (urlCurrency !== currency) {
        onCurrencyChange(urlCurrency);
      }

      if (searchParams.get("projections") == null) {
        addShowProjectionsParam("", { checked: checkSwitchShowProjections });
      } else if (urlProjections !== checkSwitchShowProjections) {
        //onChangeSwitchShowProjections(urlProjections);
      }
    }
  }, [
    location.search,
    holdingFlowFetching,
    updateHoldingCashFlowNeeded?.reload,
    data,
    holdingFlowStructure?.getFlowStructure,
  ]);

  const onViewChange = async (value) => {
    addViewTypeParam(value);
    setLoadingMsg(LoadingViewMessage[value]);
    const [_, setStartDate] = Start;
    setView(value);
    setIsLoading(true);
    setStartDate(
      moment().startOf(value).subtract(1, value).format("YYYY-MM-DD")
    );

    dispatch(importUpdateHoldingCashFlowNeeded({ value: false, reload: true }));
    await new Promise((res) => setTimeout(res, 4000));
    setIsLoading(false);
  };

  const onCurrencyChange = (value) => {
    addCurrencyParam(value);
    setLoadingMsg(LoadingCurrencyMessage[value]);
    const [_, setStartDate] = Start;

    setCurrency(value);
    setStartDate(moment().startOf(view).subtract(1, view).format("YYYY-MM-DD"));
    dispatch(importUpdateHoldingCashFlowNeeded({ value: false, reload: true }));
  };

  const onChangeSwitchShowProjections = async (_, v) => {
    addShowProjectionsParam(_, v);
    const showProjections = v?.checked;

    setLoadingMsg(LoadingProjectionMessage[String(showProjections)]);
    setCheckSwitchShowProjections(showProjections);
  }

  const onChangeSwitchOnlyEstimations = async (_, v) => {
    const onlyEstimations = v?.checked;
    searchParams.set("onlyEstimations", onlyEstimations);
    history.push({ search: searchParams.toString() });
    setLoadingMsg(LoadingOnlyEstimationsMessage[String(onlyEstimations)]);
    setCheckSwitchOnlyEstimations(onlyEstimations);
  }

  const handleInputChange = (event) => {
    setFilterInputValue(event.target.value);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAreaFilter(filterInputValue);
    }, 500);

    return () => clearTimeout(timer);
  }, [filterInputValue]);

  useEffect(() => {
    if (!mergeAreasModalData) return;

    setMergeAreasModalIsOpen(true);
  }, [mergeAreasModalData])

  const syncAreaConflictsFromStructure = useCallback((openModalIfNeeded = false) => {
    const resolutionStatus = window.localStorage.getItem(conflictStorageKey);
    const isDeferred = resolutionStatus === "deferred";
    setConflictsReviewDeferred(isDeferred);

    if (resolutionStatus === "resolved-manual") {
      setAreaConflicts([]);
      return;
    }

    const structure = holdingFlowStructure?.getHoldingFlowStructure?.[0];
    if (!structure?.report || !data?.getHoldingCashFlow?.id) return;

    const conflicts = detectAreaConflicts(structure.report);
    if (conflicts.length === 0) {
      setAreaConflicts([]);
      window.localStorage.removeItem(conflictStorageKey);
      setConflictsReviewDeferred(false);
      return;
    }

    const initialDecisions = conflicts.reduce((acc, conflict) => {
      acc[conflict.conflictKey] = "separate";
      return acc;
    }, {});
    const initialNames = conflicts.reduce((acc, conflict) => {
      acc[conflict.conflictKey] = conflict.mergedAreaName || "";
      return acc;
    }, {});

    setAreaConflicts(conflicts);
    setAreaConflictDecisions((prev) => (
      openModalIfNeeded || !isDeferred ? initialDecisions : { ...initialDecisions, ...prev }
    ));
    setInitialConflictDecisions(initialDecisions);
    setAreaConflictNames((prev) => (
      openModalIfNeeded || !isDeferred ? initialNames : { ...initialNames, ...prev }
    ));

    if (openModalIfNeeded && !isDeferred) {
      setAreaConflictsModalOpen(true);
    }
  }, [
    conflictStorageKey,
    data?.getHoldingCashFlow?.id,
    holdingFlowStructure?.getHoldingFlowStructure,
  ]);

  useEffect(() => {
    syncAreaConflictsFromStructure(true);
  }, [syncAreaConflictsFromStructure]);

  useEffect(() => {
    if (!conflictsReviewDeferred) return;
    syncAreaConflictsFromStructure(false);
  }, [
    conflictsReviewDeferred,
    holdingFlowStructure?.getHoldingFlowStructure,
    data?.getHoldingCashFlow?.id,
    syncAreaConflictsFromStructure,
  ]);

  const deferredAreaConflicts = conflictsReviewDeferred ? areaConflicts : [];

  const closeConflictModal = () => {
    if (hasUnsavedConflictChanges) {
      const shouldDiscard = window.confirm("Tienes cambios sin aplicar. ¿Quieres cerrar y descartarlos?");
      if (!shouldDiscard) return;
    }
    setAreaConflictsModalOpen(false);
  };

  const deferConflictReview = () => {
    if (hasUnsavedConflictChanges) {
      const shouldDiscard = window.confirm("Tienes cambios sin aplicar. ¿Quieres cerrar y descartarlos?");
      if (!shouldDiscard) return;
    }
    window.localStorage.setItem(conflictStorageKey, "deferred");
    setConflictsReviewDeferred(true);
    setAreaConflictsModalOpen(false);
  };

  const openAreaConflictsModal = () => {
    setAreaConflictsModalOpen(true);
  };

  const applyConflictSelection = async () => {
    if (!data?.getHoldingCashFlow?.id || !areaConflicts?.length) return;

    const selectedConflictsToMerge = areaConflicts.filter(
      (conflict) => areaConflictDecisions?.[conflict.conflictKey] === "merge"
    );

    const conflictsWithoutName = selectedConflictsToMerge.filter(
      (conflict) => !areaConflictNames?.[conflict.conflictKey]?.trim()
    );
    if (conflictsWithoutName.length > 0) {
      dispatch(importAlertState({
        content: "Debes ingresar el nombre para cada conflicto marcado como combinar.",
        state: "error",
        duration: 5
      }));
      return;
    }

    const failedMerges = [];

    for (const conflict of selectedConflictsToMerge) {
      if ((conflict?.areaRefs || []).length < 2) continue;
      const { data: mergeData, error } = await mergeCategoryAreasExecuteMutation({
        mergedAreaName: areaConflictNames?.[conflict.conflictKey]?.trim(),
        targetCategoryId: conflict.categoryId,
        areaIdsToMerge: conflict.areaRefs,
        holdingFlowId: data.getHoldingCashFlow.id,
      });
      const mergeMessage =
        mergeData?.mergeCategoryAreas?.message ||
        error?.message ||
        "";
      const alreadyCombined =
        /ya est[aá]n combinadas|ya fue aplicada previamente/i.test(mergeMessage);
      if ((error || mergeData?.mergeCategoryAreas?.status !== "success") && !alreadyCombined) {
        failedMerges.push(conflict);
      }
    }

    await reExecuteQueryHoldingFlowStructure({ requestPolicy: "network-only" });
    await reexecuteHoldingFlow({ requestPolicy: "network-only" });

    if (failedMerges.length > 0) {
      dispatch(importAlertState({
        content: `No se pudieron combinar ${failedMerges.length} conflicto(s). Revisa los nombres y vuelve a intentar.`,
        state: "error",
        duration: 6
      }));
      return;
    }

    window.localStorage.setItem(conflictStorageKey, "resolved-manual");
    setConflictsReviewDeferred(false);
    setAreaConflicts([]);
    setAreaConflictsModalOpen(false);
    dispatch(importAlertState({
      content: "Selección aplicada correctamente.",
      state: "success",
      duration: 4
    }));
  };

  const handleBitacoraClick = () => {
    dispatch(importOpenSidebar({
      show: true,
      bitacora: true,
      bitacoraExpanded: false,
      openBitacora: true,
      bitacoraCompanyId: companyId,
    }));
  };

  const handleBitacoraHistoryClose = () => {
    dispatch(importOpenSidebar({
      ...openSidebar,
      historyView: false,
      bitacora: true,
      openBitacora: true,
      bitacoraCompanyId: companyId,
    }));
  };

  const handleCloseSidebar = () => {
    dispatch(importOpenSidebar({ show: false }));
  };

  const pageForms = {
    fieldDetail: {
      title: nameSelected,
      form: FlowDetail,
    },
    initialBalance: {
      title: "Saldo Inicial",
      form: InitialBalance,
    },
    exportCashFlow: {
      title: "Exportar Flujo de Caja",
      form: ExportCashFlow,
    },
  };

  return (
    <>
      <div className="flowTableContainer shadow" style={{ width: "calc(100% - 50px)" }}>
        <div style={{ height: tableHeight - 75 }}>
          {holdingFlowFetching && isFirstRender ? (
            <>
              <div className="containerTable">
                <div className="flowSpinner">
                  <LoadingSpinner height="60px" afterHeight="60px" afterWidth="60px" />
                </div>
                <div className="containerTable__cardPreLoader" style={{ height: "80vh" }}></div>
              </div>
            </>
          ) : (
            <div className="container-fluid position-relative">
              <CRow>
                <div className="flowPeriodInputs">
                  <div className="position-absolute d-flex align-items-end" style={{ zIndex: 4, gap: '8px' }}>
                    <div>
                      <label>Vista actual:</label>
                      <div className={`flow-custom-dropdown flow-custom-dropdown--fluid${viewDropdownOpen ? ' open' : ''}`} ref={viewDropdownRef}>
                        <div className="flow-custom-dropdown__input" onClick={() => setViewDropdownOpen(!viewDropdownOpen)}>
                          <span>{VIEW_OPTIONS.find(o => o.value === (view || defaultView?.view))?.text || 'Seleccionar una vista'}</span>
                          <svg className="flow-custom-dropdown__arrow" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M2.5 4.5L6 8L9.5 4.5" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                        {viewDropdownOpen && (
                          <ul className="flow-custom-dropdown__menu">
                            {VIEW_OPTIONS.map(opt => (
                              <li
                                key={opt.key}
                                className={`flow-custom-dropdown__option${(view || defaultView?.view) === opt.value ? ' selected' : ''}`}
                                onClick={() => { onViewChange(opt.value); setViewDropdownOpen(false); }}
                              >
                                {opt.text}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                    <button
                      className="holding-merge-btn"
                      onClick={() => setMergeAreasModalIsOpen(true)}
                      type="button"
                    >
                      Combinar áreas
                    </button>
                  </div>
                  <div className="flowArrows">
                    <div className="angleLeft">
                      <button className="flow-arrow-btn" onClick={less} type="button" aria-label="Anterior">
                        <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                          <path d="M5 1L1 5L5 9" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </button>
                    </div>
                    <div className="angleRight">
                      <button className="flow-arrow-btn" onClick={plus} type="button" aria-label="Siguiente">
                        <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                          <path d="M1 1L5 5L1 9" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </button>
                    </div>
                    <div className="flowToggle">
                      <label className="flow-toggle-switch pr-3">
                        <input type="checkbox" checked={showAll} onChange={(e) => setShowAll(e.target.checked)} />
                        <span className="flow-toggle-slider"></span>
                        <span className="flow-toggle-label">Mostrar todas las filas</span>
                      </label>
                      <label className="flow-toggle-switch pr-3">
                        <input type="checkbox" checked={checkSwitch} onChange={(e) => { setCheckSwitch(e.target.checked); setUpdateCompress(true); }} />
                        <span className="flow-toggle-slider"></span>
                        <span className="flow-toggle-label">Colapsar</span>
                      </label>
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label>Vista actual:</label>
                        <div className={`flow-custom-dropdown flow-custom-dropdown--compact${viewModeOpen ? ' open' : ''}`} ref={viewModeRef}>
                          <div className="flow-custom-dropdown__input" onClick={() => setViewModeOpen(!viewModeOpen)}>
                            <span>{VIEW_MODE_OPTIONS.find(o => o.value === viewMode)?.text}</span>
                            <svg className="flow-custom-dropdown__arrow" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path d="M2.5 4.5L6 8L9.5 4.5" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                          {viewModeOpen && (
                            <ul className="flow-custom-dropdown__menu">
                              {VIEW_MODE_OPTIONS.map(opt => (
                                <li
                                  key={opt.key}
                                  className={`flow-custom-dropdown__option${viewMode === opt.value ? ' selected' : ''}`}
                                  onClick={() => { onViewModeChange(opt.value); setViewModeOpen(false); }}
                                >
                                  {opt.text}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label>Vista actual:</label>
                        <div className={`flow-custom-dropdown flow-custom-dropdown--compact${currencyOpen ? ' open' : ''}`} ref={currencyRef}>
                          <div className="flow-custom-dropdown__input" onClick={() => setCurrencyOpen(!currencyOpen)}>
                            <span className="flow-currency-flag">
                              <img src={`https://flagcdn.com/16x12/${CURRENCY_OPTIONS.find(o => o.value === currency)?.flag || 'cl'}.png`} alt="" />
                            </span>
                            <span>{CURRENCY_OPTIONS.find(o => o.value === currency)?.text || 'Moneda'}</span>
                            <svg className="flow-custom-dropdown__arrow" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path d="M2.5 4.5L6 8L9.5 4.5" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                          {currencyOpen && (
                            <ul className="flow-custom-dropdown__menu">
                              {CURRENCY_OPTIONS.map(opt => (
                                <li
                                  key={opt.key}
                                  className={`flow-custom-dropdown__option${currency === opt.value ? ' selected' : ''}`}
                                  onClick={() => { onCurrencyChange(opt.value); setCurrencyOpen(false); }}
                                >
                                  <img className="flow-currency-flag" src={`https://flagcdn.com/16x12/${opt.flag}.png`} alt="" />
                                  {opt.text}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <HoldingFlow
                  getFlow={data?.getHoldingCashFlow}
                  flowStructure={holdingFlowStructure?.getHoldingFlowStructure}
                  view={view || defaultView?.view}
                  setNameSelected={setNameSelected}
                  tableHeight={tableHeight}
                  loading={holdingFlowFetching || isLoading}
                  loadingMsg={loadingMsg}
                  start={Start}
                  end={End}
                  checkSwitch={checkSwitch}
                  setCheckSwitch={setCheckSwitch}
                  updateCompress={updateCompress}
                  setUpdateCompress={setUpdateCompress}
                  showAll={showAll}
                  isHolding={true}
                  holdingCompanyIds={selectedCompanies}
                  plus={plus}
                  less={less}
                  handleInputChange={handleInputChange}
                  setMergeAreasModalData={setMergeAreasModalData}
                  deferredAreaConflicts={deferredAreaConflicts}
                  onOpenAreaConflictsModal={openAreaConflictsModal}
                  screenshotRef={screenshotRef}
                  screenshotPrepareRef={screenshotPrepareRef}
                  onScreenshotCapture={() =>
                    captureFlowTableScreenshot(
                      screenshotRef.current,
                      "flujo-caja-consolidado.png",
                      screenshotPrepareRef
                    )
                  }
                />
              </CRow>
            </div>
          )}
        </div>
      </div>
      <RightSidebar
        page="flujocaja"
        pageForms={pageForms}
        onBitacoraClick={handleBitacoraClick}
        closeMenuFunctions={{ historyView: handleBitacoraHistoryClose, closeSidebar: handleCloseSidebar }}
        iconsToHide={["iconAgregar", "editarIcon", "importObligations", "addCredit", "flowComments"]}
        canSeeBitacora
      />

      <MergeAreasModal
        modalIsOpen={mergeAreasModalIsOpen}
        incomeList={holdingFlowStructure?.getHoldingFlowStructure?.[0]?.report?.INCOME}
        expenseList={holdingFlowStructure?.getHoldingFlowStructure?.[0]?.report?.EXPENSE}
        holdingCashFlowId={data?.getHoldingCashFlow?.id}
        setMergeAreasModalIsOpen={setMergeAreasModalIsOpen}
        reexecuteHoldingFlow={reexecuteHoldingFlow}
        mergeAreasModalData={mergeAreasModalData}
        setMergeAreasModalData={setMergeAreasModalData}
        reExecuteQueryHoldingFlowStructure={reExecuteQueryHoldingFlowStructure}
      />

      <CustomModal
        open={areaConflictsModalOpen}
        onClose={closeConflictModal}
        title={"Revisión inicial de áreas consolidadas"}
        size="large"
        classNameModal="conflicts-resolution-modal"
        classNameContent="conflicts-resolution-modal-content-wrapper"
        modalStyle={{ width: "min(1080px, 96vw)" }}
        content={
          <div className="conflicts-resolution-modal-body">
            <div className="conflicts-resolution-description">
              Estás entrando por primera vez a la vista consolidada. Detectamos áreas que comparten el mismo origen entre empresas, pero llegan con nombres distintos. En esta revisión puedes decidir si quieres verlas como una sola área consolidada o mantenerlas separadas para conservar el detalle.
            </div>

            <div className="conflicts-resolution-summary">
              <div className="conflicts-resolution-count">
                {conflictsCount} casos por revisar · {combinedCount} para combinar · {separatedCount} separadas
              </div>
            </div>

            <div className="conflicts-resolution-list">
              {areaConflicts.map((conflict, idx) => (
                <section
                  key={`${conflict.areaId}-${idx}`}
                  aria-label={`Conflicto ${idx + 1}: ${conflict.categoryLabel}`}
                  className="conflict-card"
                >
                  <div className="conflict-card-title">Conflicto {idx + 1}</div>
                  <div className="conflict-card-meta">
                    {conflict.reportType === "INCOME" ? "Ingresos" : "Egresos"} · {conflict.categoryLabel}
                    {conflict.conflictType === "areaId-category" && (
                      <span className="conflict-badge-category"> · aparece en distintas categorías</span>
                    )}
                  </div>

                  <div className="conflict-chip-label">Cómo aparece en las empresas</div>
                  <div className="chip-list">
                    {[...new Set(conflict.labels)].map((label) => (
                      <span key={`${conflict.conflictKey}-${label}`} className="chip">
                        {label}
                      </span>
                    ))}
                  </div>

                  <div className="conflict-chip-label">¿Qué quieres hacer?</div>
                  <div role="radiogroup" aria-label={`Decisión para conflicto ${idx + 1}`} className="decision-segmented">
                    <button
                      className={`decision-segment ${areaConflictDecisions?.[conflict.conflictKey] === "separate" ? "active" : ""}`}
                      onClick={() =>
                        setAreaConflictDecisions((prev) => ({
                          ...prev,
                          [conflict.conflictKey]: "separate",
                        }))
                      }
                      type="button"
                    >
                      Dejar separadas
                    </button>
                    <button
                      className={`decision-segment ${areaConflictDecisions?.[conflict.conflictKey] === "merge" ? "active" : ""}`}
                      onClick={() =>
                        setAreaConflictDecisions((prev) => ({
                          ...prev,
                          [conflict.conflictKey]: "merge",
                        }))
                      }
                      type="button"
                    >
                      Combinar
                    </button>
                  </div>
                  <div className="conflict-card-meta">
                    Si combinas, verás una sola fila en el consolidado. Luego podrás editar o separar desde "Combinar áreas".
                  </div>
                  {areaConflictDecisions?.[conflict.conflictKey] === "merge" && (
                    <>
                      <div className="conflict-chip-label">Nombre del área combinada</div>
                      <input
                        className="conflict-name-input"
                        type="text"
                        value={areaConflictNames?.[conflict.conflictKey] || ""}
                        onChange={(event) =>
                          setAreaConflictNames((prev) => ({
                            ...prev,
                            [conflict.conflictKey]: event.target.value,
                          }))
                        }
                        placeholder="Ingresa nombre para el área combinada"
                      />
                    </>
                  )}
                </section>
              ))}
            </div>
          </div>
        }
        customActions={
          <div className="tw-flex tw-justify-end tw-gap-2">
            <button className="ui button" onClick={deferConflictReview}>Revisar más tarde</button>
            <button className="ui blue button" onClick={applyConflictSelection}>Guardar y continuar</button>
          </div>
        }
      />
    </>
  )
}